import React, { FC, memo } from 'react';
import { Text, View } from '@react-pdf/renderer';

import { BASE_FONT_SIZE } from '../pdfStyles';
import { BaseServiceVoucherInfoType } from '../Vouchers/voucherHelpers';

type Props = {
    supplierName: BaseServiceVoucherInfoType['supplierName'];
    supplierDetails: BaseServiceVoucherInfoType['supplierDetails'];
};

const PdfSupplierDetails: FC<Props> = (props: Props) => {
    const { supplierName, supplierDetails } = props;

    // Build address lines
    const addressLines: string[] = [];
    if (supplierDetails?.address) {
        const addr = supplierDetails.address;
        if (addr.address) addr.address.trim().split(/\r?\n/).forEach((l: string) => { if (l.trim()) addressLines.push(l.trim()); });
        if (addr.city) addressLines.push(addr.city.trim());
        if (addr.postalCode) addressLines.push(addr.postalCode.trim());
        if (addr.country?.name) addressLines.push(addr.country.name.trim());
    }

    // Dedupe phones, keep Main Phone + Main Fax
    const seen = new Set<string>();
    const displayPhones = (supplierDetails?.phones || []).filter((phone) => {
        if (!phone?.number) return false;
        const key = `${phone.type}|${phone.number}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
    }).filter(p => p.type === 'Main Phone' || p.type === 'Main Fax');

    return (
        <View style={{ marginBottom: 4 }}>
            <Text style={{ fontWeight: 'bold', fontSize: BASE_FONT_SIZE + 1, marginBottom: 2 }}>
                {(supplierName || '').trim()}
            </Text>
            {addressLines.length > 0 && (
                <View style={{ marginBottom: 2 }}>
                    {addressLines.map((line, idx) => (
                        <Text key={idx} style={{ fontSize: BASE_FONT_SIZE, color: '#555' }}>{line}</Text>
                    ))}
                </View>
            )}
            {displayPhones.length > 0 && (
                <View style={{ marginTop: 2 }}>
                    {displayPhones.map((phone, idx) => (
                        <View key={idx} style={{ flexDirection: 'row', paddingVertical: 1 }}>
                            <Text style={{ width: 45, fontSize: BASE_FONT_SIZE, color: '#777' }}>
                                {(phone.type || '').replace('Main ', '').replace(' Phone', '')}:
                            </Text>
                            <Text style={{ fontSize: BASE_FONT_SIZE }}>{phone.number}</Text>
                        </View>
                    ))}
                </View>
            )}
        </View>
    );
};

export default memo(PdfSupplierDetails);
